import { RoleTelemetryKeys } from './rolesTelemetryConstant';

export interface ITelemetryEvent {
  name: string;
  properties?: Map<RoleTelemetryKeys, string | number | boolean>;
  errorEvent?: {
    eventName: string;
    eventProperties?: Map<RoleTelemetryKeys, number | string | boolean>;
  };
}

export type EventFlow = Record<string, ITelemetryEvent>;

export const roleTelemetryEvents: Record<string, EventFlow> = {
  addCustomRoleFlow: {
    start: {
      name: 'Add Custom Role: Started',
    },
    roleDetailsAdded: {
      name: 'Add Custom Role: Role Details Added',
    },
    addedPermissionDetails: {
      name: 'Add Custom Role: Added Permission Details',
      errorEvent: {
        eventName: 'Add Custom Role: Error Getting Permission/Capability',
      },
    },
    createdRole: {
      name: 'Add Custom Role: Created Role',
      errorEvent: {
        eventName: 'Add Custom Role: Role Creation Failed',
      },
    },
  },
  editCustomRole: {
    start: {
      name: 'Edit Custom Role: Started',
      errorEvent: {
        eventName: 'Edit Role: Could Not Retrieve Product Roles',
      },
    },
    editedRoleDetails: {
      name: 'Edit Custom Role: Edited Role Details',
      properties: new Map([[RoleTelemetryKeys.WasRoleNameChanged, false]]),
    },
    editedPermissionDetails: {
      name: 'Edit Custom Role: Edited Permission Details',
      errorEvent: {
        eventName: 'Edit Role: Error Getting Permission/Capability',
      },
    },
    savedRoleChanges: {
      name: 'Edit Custom Role: Saved Role Changes',
      errorEvent: {
        eventName: 'Edit Role: Save Failed',
      },
    },
  },
  assignRoleFlow: {
    start: {
      name: 'Assign Role: Started',
      properties: new Map([[RoleTelemetryKeys.RoleType, 'static']]),
    },
    instanceAdded: {
      name: 'Assign Role: Selected Where To Assign',
    },
    addedPermissionDetails: {
      name: 'Assign Role: Selected Users/Groups And Role Assigned',
      properties: new Map([
        [RoleTelemetryKeys.NoOfUsersSelected, 0],
        [RoleTelemetryKeys.NoOfGroupsSelected, 0],
      ]),
      errorEvent: {
        eventName: 'Assign Role: Errors Occurred While Assigning Roles',
      },
    },
  },
  unAssignRoleFlow: {
    removedUserFromRoles: {
      name: 'Unassign User: User removed from roles',
      errorEvent: {
        eventName: 'Assign Role: Error Occurred While Unassigning Role',
      },
    },
    removedGroupFromRoles: {
      name: 'Unassign Group: Group removed from roles',
      errorEvent: {
        eventName: 'Assign Role: Error Occurred While Removing Group From Role',
      },
    },
  },
  viewDeleteFilterRolesOperations: {
    rolesDetailsViewed: {
      name: 'Roles: Roles Details Viewed',
      properties: new Map([[RoleTelemetryKeys.RoleType, 'static']]),
      errorEvent: {
        eventName: 'Roles: Error Viewing Role Details',
      },
    },
    editCustomRoleFromRolesDetails: {
      name: 'Edit Custom Role: Started',
      properties: new Map([
        [RoleTelemetryKeys.IsEventFromRolesDetails, 'true'],
      ]),
      errorEvent: {
        eventName: 'Edit Custom Role: Could Not Retrieve Product Roles',
      },
    },
    deletedUserRole: {
      name: 'Roles: Deleted User Role',
      properties: new Map([
        [RoleTelemetryKeys.IsEventFromRolesDetails, 'true'],
      ]),
      errorEvent: {
        eventName: 'Delete Role: Failed',
      },
    },
    assignRoleStart: {
      name: 'Assign Role: Started',
      properties: new Map([
        [RoleTelemetryKeys.IsEventFromRolesDetails, 'true'],
      ]),
    },
    productServiceFilter: {
      name: 'Roles: Product/Service Filter Applied',
    },
    rolesTypeFilter: {
      name: 'Roles: Roles Type Filter Applied',
    },
  },
};
